import type * as React from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { COLORS } from "components/v3/Theme/colors";
import Translate from "translate/Translate";
import GLButton from "components/v3/sharedComponents/GLButton";
import ModalWrapper from "components/v2/sharedComponents/Modals/ModalComponents/ModalWrapper";

const DEFAULT_DESCRIPTION =
  "If you exit, your answers will not be saved and you will need to start from the beginning next time.";

type GettingStartedSurveyExitConfirmationModalProps = {
  descriptionText?: string;
  exitTo?: string;
  isOpen?: boolean;
  onCloseModal?: () => void;
};

const GettingStartedSurveyExitConfirmationModal: React.FC<
  GettingStartedSurveyExitConfirmationModalProps
> = ({
  descriptionText = DEFAULT_DESCRIPTION,
  exitTo = "/",
  isOpen = false,
  onCloseModal
}) => {
  return (
    <ModalWrapper
      closeOnBackdropClick={true}
      isOpen={isOpen}
      onClose={onCloseModal}
      modalContainerSx={{
        borderRadius: "24px !important",
        flexBasis: {
          xs: "90% !important"
        },
        maxHeight: "85vh",
        maxWidth: {
          xs: "95%",
          md: "640px !important"
        },
        overflow: "visible",
        padding: {
          xs: "40px 24px 32px 24px !important",
          md: "56px 48px 40px 48px !important"
        },
        margin: "auto",
        outline: 0
      }}
      sx={{
        "& .MuiModal-backdrop": {
          backgroundColor: `${COLORS.PRIMARY_DARKER}80`
        },
        outline: 0
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: 4,
          textAlign: "center",
          width: "100%"
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            maxWidth: { md: "90%", xs: "100%" }
          }}
        >
          <Typography
            component="h2"
            variant="body_strong_lg_black"
            sx={{ m: 0 }}
          >
            <Translate text="Are you sure you want to exit?" />
          </Typography>
          <Typography component="p" variant="body_black" sx={{ m: 0 }}>
            <Translate text={descriptionText} />
          </Typography>
        </Box>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: 2.5
          }}
        >
          <Link
            to={exitTo}
            style={{
              textDecoration: "none"
            }}
          >
            <GLButton buttonType="primary">
              <Typography variant="body_strong_white">
                <Translate text="Exit anyway" />
              </Typography>
            </GLButton>
          </Link>
          <Box
            component="button"
            onClick={() => {
              onCloseModal();
            }}
            sx={{
              background: "transparent",
              border: "none",
              cursor: "pointer"
            }}
          >
            <Typography variant="body_strong_dark_gray">
              <Translate text="Never mind, continue answering" />
            </Typography>
          </Box>
        </Box>
      </Box>
    </ModalWrapper>
  );
};

export default GettingStartedSurveyExitConfirmationModal;
